// HDF5 upload flow shared by the Data folder button and the
// top-bar upload icon.
//
// `pickAndUploadHDF5()` opens a hidden <input type="file"> and, on selection,
// registers the file as an uploaded dataset, points params.dataset at it,
// and dispatches SWITCH_DATASET. We pre-write params.dataset because the
// SWITCH_DATASET handler itself does not (the pane's own binding writes the
// proxy before dispatching). A `magviz:uploaded-datasets-changed` window
// event lets open UI (e.g. the top-bar dropdown) refresh its options list.

import { uploadedDatasets } from './uploadedDatasets';
import { params, store } from '@store/instance';
import { INTENTS } from '@store/intents';

export const UPLOADED_DATASETS_CHANGED = 'magviz:uploaded-datasets-changed';

interface PickOpts {
    onAfter?: () => void;
}

export function pickAndUploadHDF5(opts: PickOpts = {}): void {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.h5,.hdf5,application/octet-stream,application/x-hdf,application/x-hdf5';
    input.style.display = 'none';
    document.body.appendChild(input);
    input.onchange = async (): Promise<void> => {
        const file = input.files && input.files[0] ? input.files[0] : null;
        try { if (file) await applyUploadedFile(file); }
        catch (e) { console.warn('Failed to load uploaded dataset:', e); }
        try { input.remove(); } catch { /* swallow */ }
        try { opts.onAfter?.(); } catch { /* swallow */ }
    };
    input.click();
}

async function applyUploadedFile(file: File): Promise<void> {
    const url = URL.createObjectURL(file);
    const displayName = file.name.replace(/\.(h5|hdf5)$/i, '');
    uploadedDatasets.set(displayName, url);
    try { params.dataset = displayName; } catch { /* swallow */ }
    store.dispatch(INTENTS.SWITCH_DATASET, { key: displayName });
    try { window.dispatchEvent(new CustomEvent(UPLOADED_DATASETS_CHANGED)); } catch { /* swallow */ }
}
